import { useCartState } from '../contexts/cart';
import { useCheckAuthorityType, useCheckUser } from './useCheckUser';
import { isValidString, logError } from '../components/global/utils/logger';
import {
    FORM_STEP_CASH,
    FORM_STEP_CASH_WO_OPTIONAL,
    FORM_STEP_CREATE_QUOTE,
    FORM_STEP_CREATE_QUOTE_WO_OPTIONAL,
    FORM_STEP_CREDIT_JOBSITE,
    FORM_STEP_CREDIT_WO_OPTIONAL,
    FORM_STEP_CUSTOM_CREDIT,
    FORM_STEP_CUSTOM_CREDIT_WO_OPTIONAL,
    FORM_STEP_GUEST,
    FORM_STEP_GUEST_WO_OPTIONAL,
    FORM_STEP_CREDIT_ADDRESS,
    FORM_STEP_CREDIT_WO_OPTIONAL_ADDRESS,
    FORM_STEP_CUSTOM_CREDIT_WO_OPTIONAL_ADDRESS,
    FORM_STEP_CUSTOM_CREDIT_ADDRESS,
    FORM_STEP_CREDIT_CREATE_QUOTE,
    FORM_STEP_CREDIT_CREATE_QUOTE_WO_OPTIONAL
} from '../components/checkoutv2/constants';
import { STORAGE_CONFIG } from '../constants/storageConfig';
import { AUTHORITY_TYPE } from '../components/global/constants';
import { USER_TYPE } from '../constants/userDetailsConstants';

const useCheckout = () => {
    const [{ isCreditNewAddress, optionalPlan }] = useCartState();
    const userType = useCheckUser();
    const authorityType = useCheckAuthorityType();

    const getFormStep = (currentStep, setFormStep, isCustomAccount) => {
        try {
            let formStepCredit;
            let formStepCreditWoOptional;
            let formStepCustomCreditWoOptional;
            let formStepCustomCredit;
            if (
                isCreditNewAddress ||
                isValidString(localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.ISCREATEJOBSITE))
            ) {
                formStepCredit = FORM_STEP_CREDIT_ADDRESS;
                formStepCreditWoOptional = FORM_STEP_CREDIT_WO_OPTIONAL_ADDRESS;
                formStepCustomCreditWoOptional = FORM_STEP_CUSTOM_CREDIT_WO_OPTIONAL_ADDRESS;
                formStepCustomCredit = FORM_STEP_CUSTOM_CREDIT_ADDRESS;
            } else {
                formStepCredit = FORM_STEP_CREDIT_JOBSITE;
                formStepCreditWoOptional = FORM_STEP_CREDIT_WO_OPTIONAL;
                formStepCustomCreditWoOptional = FORM_STEP_CUSTOM_CREDIT_WO_OPTIONAL;
                formStepCustomCredit = FORM_STEP_CUSTOM_CREDIT;
            }
            if (userType === USER_TYPE.CREDIT && authorityType === AUTHORITY_TYPE.P2P) {
                const isNewAddressOrCreateJobSite =
                    isCreditNewAddress ||
                    isValidString(localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.ISCREATEJOBSITE));
                const isOptionalVisible = optionalPlan.isRPPCheckboxVisible || optionalPlan.isFuelCheckboxVisible;
                if (isNewAddressOrCreateJobSite) {
                    if (isOptionalVisible) {
                        setFormStep(FORM_STEP_CREDIT_CREATE_QUOTE);
                    } else {
                        setFormStep(FORM_STEP_CREDIT_CREATE_QUOTE_WO_OPTIONAL);
                    }
                } else {
                    if (isOptionalVisible) {
                        setFormStep(FORM_STEP_CREATE_QUOTE);
                    } else {
                        setFormStep(FORM_STEP_CREATE_QUOTE_WO_OPTIONAL);
                    }
                }
            } else if (userType === USER_TYPE.CREDIT && !isCustomAccount) {
                if (optionalPlan.isRPPCheckboxVisible || optionalPlan.isFuelCheckboxVisible) {
                    setFormStep(formStepCredit);
                } else {
                    setFormStep(formStepCreditWoOptional);
                }
            } else if (userType === USER_TYPE.CREDIT && isCustomAccount) {
                if (optionalPlan.isRPPCheckboxVisible || optionalPlan.isFuelCheckboxVisible) {
                    setFormStep(formStepCustomCredit);
                } else {
                    setFormStep(formStepCustomCreditWoOptional);
                }
            } else if (userType === USER_TYPE.CASH) {
                if (optionalPlan.isRPPCheckboxVisible || optionalPlan.isFuelCheckboxVisible) {
                    setFormStep(FORM_STEP_CASH);
                } else {
                    setFormStep(FORM_STEP_CASH_WO_OPTIONAL);
                }
            } else if (userType === USER_TYPE.GUEST) {
                if (optionalPlan.isRPPCheckboxVisible || optionalPlan.isFuelCheckboxVisible) {
                    setFormStep(FORM_STEP_GUEST);
                } else {
                    setFormStep(FORM_STEP_GUEST_WO_OPTIONAL);
                }
            }
        } catch (error) {
            logError(error, false, 'useCheckout - getFormStep', [currentStep, setFormStep, isCustomAccount]);
        }
    };

    return {
        getFormStep
    }
};

export default useCheckout;
